// extracted by mini-css-extract-plugin
module.exports = {"optContainer":"styles_optContainer__RVLeA"};